import { render } from "./AppConfig.vue?vue&type=template&id=7bf26b66&scoped=true"
import script from "./AppConfig.vue?vue&type=script&lang=js"
export * from "./AppConfig.vue?vue&type=script&lang=js"

import "./AppConfig.vue?vue&type=style&index=0&id=7bf26b66&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf26b66"]])

export default __exports__